// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e8f0ac12","162":"63b01cae","587":"1300caf7","787":"07698f23"}[chunkId] + ".chunk.js";
};